import FilterChip from '@/components/base/FilterChip';
import { genreOptions, regionOptions, yearOptions } from '@/mocks/filters';

export interface CategoryFilterState {
  types: string[];
  genres: string[];
  years: number[];
  regions: string[];
  sort: 'date' | 'hot';
}

interface CategoryFiltersProps {
  filters: CategoryFilterState;
  onToggle: (group: 'types' | 'genres' | 'years' | 'regions', value: string | number) => void;
  onSortChange: (sort: 'date' | 'hot') => void;
  onReset: () => void;
}

function Group({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4 py-3 border-b border-background-200/60 last:border-b-0">
      <span className="shrink-0 md:w-16 text-xs md:text-sm text-foreground-500 pt-1">{label}</span>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  );
}

export default function CategoryFilters({ filters, onToggle, onSortChange, onReset }: CategoryFiltersProps) {
  return (
    <div className="bg-background-100 border border-background-200/70 rounded-lg p-4 md:p-5">
      <Group label="分类">
        <FilterChip label="全部" active={filters.types.length === 0} onClick={() => onToggle('types', 'all')} />
        <FilterChip label="电影" active={filters.types.includes('movie')} onClick={() => onToggle('types', 'movie')} />
        <FilterChip label="电视剧" active={filters.types.includes('tv')} onClick={() => onToggle('types', 'tv')} />
      </Group>

      <Group label="类型">
        {genreOptions.map((g) => (
          <FilterChip key={g} label={g} active={filters.genres.includes(g)} onClick={() => onToggle('genres', g)} />
        ))}
      </Group>

      <Group label="年份">
        {yearOptions.map((y) => (
          <FilterChip
            key={y}
            label={String(y)}
            active={filters.years.includes(y)}
            onClick={() => onToggle('years', y)}
          />
        ))}
      </Group>

      <Group label="地区">
        {regionOptions.map((r) => (
          <FilterChip key={r} label={r} active={filters.regions.includes(r)} onClick={() => onToggle('regions', r)} />
        ))}
      </Group>

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pt-4">
        <Group label="排序">
          <FilterChip label="最新上映" active={filters.sort === 'date'} onClick={() => onSortChange('date')} />
          <FilterChip label="最热热门" active={filters.sort === 'hot'} onClick={() => onSortChange('hot')} />
        </Group>
        <button
          type="button"
          onClick={onReset}
          className="shrink-0 inline-flex items-center justify-center gap-1.5 text-xs md:text-sm text-foreground-600 hover:text-primary-400 border border-background-200 hover:border-primary-400/60 rounded-md px-4 py-2 whitespace-nowrap cursor-pointer transition-colors"
        >
          <i className="ri-refresh-line" />
          重置筛选
        </button>
      </div>
    </div>
  );
}